import Flatpickr from "stimulus-flatpickr"
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect/index.js";

export default class FlatpickrMonthController extends Flatpickr {
  connect() {
    this.config = {
      position: "auto center",

      plugins: [
        new monthSelectPlugin({
          shorthand: true, // true to use shorthand month names
          dateFormat: "Y-m", // format of the date
          altFormat: "F Y", // format of the alternate date shown to the user
          theme: "dark" // theme
        })
      ]
    };

    super.connect();
  }
}
